<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn
        flat
        small
        icon
        color="grey"
        :loading="loading"
        data-test="dowloadXlsxButton"
        :disabled="disabled"
        class="ma-0"
        @click="
          () => {
            $emit('download');
          }
        "
        v-on="on"
      >
        <v-icon>grid_on</v-icon>
      </v-btn>
    </template>
    <span>Экспорт в Excel</span>
  </v-tooltip>
</template>
<script>
export default {
  props: ["loading", "disabled"],
};
</script>
